import { filter, map, startWith, take, tap, timeout } from 'rxjs'
import { isPresent } from 'ts-is-present'
import observeOnMutation from './mutation-observer'

export default function waitForElements(selectors: string[], timeoutAfter = 5000) {
	return observeOnMutation(document.body).pipe(
		startWith(document.body),
		filter(() => selectors.every(s => !!document.querySelector(s))),
		take(1),
		// TS can't narrow querySelector's return through .every() above — filter again to drop nulls.
		map(() => selectors.map(s => document.querySelector(s)).filter(isPresent)),
		map(elements => {
			if (elements.length === selectors.length) {
				return elements
			} else {
				throw new Error('Not all elements were found')
			}
		}),
		timeoutAfter ? timeout(timeoutAfter) : tap(),
	)
}
